import {cn} from '@lib/utils';
import {Badge} from '@ui/shadcn/badge';

interface PriorityBadgeProps {
  priority: 1 | 2 | 3;
  className?: string;
}

const PRIORITY_CONFIG = {
  1: {
    label: 'P1',
    classes:
      'bg-[var(--score-bad-soft)] text-[var(--score-bad)] border-[var(--score-bad)]',
  },
  2: {
    label: 'P2',
    classes:
      'bg-[var(--score-warn-soft)] text-[var(--score-warn)] border-[var(--score-warn)]',
  },
  3: {
    label: 'P3',
    classes:
      'bg-[var(--color-primary-soft)] text-[var(--color-primary)] border-[var(--color-primary)]',
  },
} as const;

/** Бейдж приоритета P1/P2/P3 — доменная обёртка над `shadcn/badge`. */
export const PriorityBadge = ({priority, className}: PriorityBadgeProps) => {
  const {label, classes} = PRIORITY_CONFIG[priority];
  return (
    <Badge
      variant='outline'
      className={cn('rounded px-1.5 py-0.5 font-bold', classes, className)}
    >
      {label}
    </Badge>
  );
};
